import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <rect
        width="16"
        height="16"
        fill="url(#paint0_linear_423_416)"
        rx="6"
      ></rect>
      <path
        fill="url(#paint1_linear_423_416)"
        d="M12.842 4.092l-2.684 1.633-1.633-1.692c-.117-.116-.35-.175-.525-.175-.175 0-.408.059-.525.175L5.842 5.725 3.158 4.092c-.466-.292-1.108.116-.991.641l1.925 7c.058.234.35.409.641.409h6.534c.291 0 .583-.175.641-.409l1.925-7c.117-.525-.525-.933-.991-.641zm-3.092 5.95h-3.5a.46.46 0 01-.467-.467c0-.292.175-.467.467-.467h3.5a.46.46 0 01.467.467.46.46 0 01-.467.467z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_423_416"
          x1="0"
          x2="15.361"
          y1="0"
          y2="0.875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4F3FC"></stop>
          <stop offset="0.542" stopColor="#D6C2FF"></stop>
          <stop offset="1" stopColor="#99B7FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_423_416"
          x1="12.078"
          x2="-0.466"
          y1="12.142"
          y2="8.737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2EFE"></stop>
          <stop offset="1" stopColor="#7896FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
